<template>
  <div class="checkbox-wrapper">
    <div v-if="prependText" class="input-group-prepend">
      <div class="input-group-text">{{ prependText }}</div>
    </div>
    <div class="form-check" v-for="item of checkboxList" :key="item.value">
      <input
        class="form-check-input"
        type="checkbox"
        :value="item.value"
        :id="item.value"
        v-model="selectedList"
      />
      <label class="form-check-label" :for="item.value">
        {{ item.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    prependText: {
      type: String,
      default: ''
    },
    defaultSelectedList: {
      type: Array,
      default: () => []
    },
    checkboxList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedList: this.defaultSelectedList
    };
  },
  watch: {
    selectedList: {
      immediate: true,
      handler(val) {
        this.$emit('onValueChange', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & > div {
    margin: 0;
  }

  .input-group-prepend {
    margin-right: 0.5rem;

    .input-group-text {
      background-color: initial;
      border: none;
      font-weight: 600;
      color: $text-black;
    }
  }

  .form-check {
    display: inline-block;
    margin-right: 1rem;
  }
}

@media screen and (max-width: 992px) {
  .checkbox-wrapper {
    flex-direction: column;
    align-items: flex-start;

    .form-check {
      display: inline-block;
      padding: 0.25rem 0;
      margin-left: 2rem;
    }
  }
}
</style>
